module.exports = __webpack_public_path__ + "static/media/22ESCWA2.3a10f851.jpg";